<template>
  <PopoverRoot>
    <PopoverTrigger :class="props.class" asChild>
      <slot />
    </PopoverTrigger>
    <PopoverPortal>
      <PopoverContent
        class="z-50 flex flex-col items-center border border-secondary rounded-md shadow-lg"
        :align="align"
      >
        <slot name="content" />
      </PopoverContent>
    </PopoverPortal>
  </PopoverRoot>
</template>

<script setup>
import {
  PopoverContent,
  PopoverPortal,
  PopoverRoot,
  PopoverTrigger,
} from "radix-vue";

const props = defineProps({
  align: {
    type: String,
    validator: (val) => ["start", "center", "end"].includes(val),
    default: "start",
  },
  class: { type: null, required: false },
});
</script>
